<template>
  <button class="inline-flex size-12 items-center justify-center rounded-full bg-background-gray text-white hover:bg-background-gray-hover md:size-14" @click="openAskly()">
    <Icon class="size-7 md:size-8" name="chat-bubble" />
  </button>
</template>

<script setup lang="ts">
import Icon from '~/components/icon/Icon.vue'

const openAskly = () => {
  useAsklyChat()

  let attempts = 0
  const maxAttempts = 10

  /* A hacky solution to load Askly API asynchronously. Could not get it to work with Nuxt Scripts */
  const interval = setInterval(() => {
    if (window.asklyApi?.openChatTab) {
      window.asklyApi.openChatTab()
      clearInterval(interval)
    } else {
      attempts++
      if (attempts >= maxAttempts) {
        clearInterval(interval)
        console.warn('Askly API not available in time.')
      }
    }
  }, 100)
}
</script>
